define((require) => {
    "use strict";

    const Backbone        = require("backbone");
    const ButtonIconModel = require("shared/ui/experience/widgets/button/ButtonIconModel");

    return Backbone.Collection.extend("ButtonIconCollection", {

        model: ButtonIconModel,

        byGroup(groupId) {
            return this.where({groupId});
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/button/ButtonIconCollection.js